import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Button } from './Button';
export const FinalCTA = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-16 md:py-32 px-4 md:px-6 bg-brown text-cream relative overflow-hidden" ref={ref} data-id="element-30">
      {/* Dramatic background elements */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#C9A96E 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-31"></div>
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-full h-full bg-gradient-to-b from-transparent to-brown pointer-events-none" data-id="element-32"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.9
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-34">
          <h2 className="text-3xl md:text-6xl font-serif mb-8 md:mb-12 leading-tight" data-id="element-35">
            Tu momento de paz <br data-id="element-36" />{' '}
            <span className="text-gold italic" data-id="element-37">comienza ahora.</span>
          </h2>

          <Button href="#oferta" className="w-full md:w-auto text-lg md:text-xl py-6 px-8 md:px-12 shadow-[0_0_40px_rgba(201,169,110,0.3)] hover:shadow-[0_0_60px_rgba(201,169,110,0.5)]" data-id="element-38">
            SÍ, QUIERO SANAR Y CREAR — ACCESO INMEDIATO POR $9.99
          </Button>

          <div className="mt-8 flex items-center justify-center space-x-4 text-sm text-cream/50 uppercase tracking-widest" data-id="element-39">
            <span data-id="element-40">Pago Seguro</span>
            <span data-id="element-41">•</span>
            <span data-id="element-42">Acceso Inmediato</span>
            <span data-id="element-43">•</span>
            <span data-id="element-44">Garantía 7 Días</span>
          </div>
        </motion.div>
      </div>
    </section>;
};